import React from 'react';

/**
 * CommissionDisclaimer — a small italic heritage note placed under any
 * product grid (home Collection, Suit Collection, Ready-to-Wear,
 * Archive page, Shop page, PDP). Copy is intentionally gentle and
 * sets buyer expectations for bespoke, hand-made artistry.
 */
const CommissionDisclaimer = ({ variant = 'default' }) => {
  return (
    <div
      className={`commission-disclaimer commission-disclaimer--${variant}`}
      role="note"
      data-testid="commission-disclaimer"
    >
      <span className="commission-disclaimer__rule" aria-hidden="true" />
      <p className="commission-disclaimer__text">
        Each Silk &amp; Sentiment creation is hand-crafted by our master karigars in Lucknow.
        Subtle variations in colour, weave and hand-embroidery are part of the artistry &mdash;
        no two pieces are ever truly identical. Photographs are indicative; actual shades may
        differ slightly across screens and natural light. Custom sizing, fabric and embroidery
        variations are warmly welcomed.
      </p>
    </div>
  );
};

// One-time scoped styles
const STYLE_ID = 'commission-disclaimer-styles';
if (typeof document !== 'undefined' && !document.getElementById(STYLE_ID)) {
  const css = document.createElement('style');
  css.id = STYLE_ID;
  css.textContent = `
    .commission-disclaimer {
      max-width: 780px;
      margin: 72px auto 0;
      padding: 0 20px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
    .commission-disclaimer--tight { margin-top: 48px; }
    .commission-disclaimer--pdp {
      margin: 28px 0 0;
      padding: 0;
      max-width: none;
      text-align: left;
      align-items: flex-start;
    }
    .commission-disclaimer__rule {
      width: 48px;
      height: 1px;
      background: var(--accent-gold);
      opacity: 0.75;
    }
    .commission-disclaimer--pdp .commission-disclaimer__rule { display: none; }

.inquiry-policy-note {
  margin: 0 0 18px;
  padding: 14px 18px;
  background: rgba(201, 169, 97, 0.08);
  border-left: 2px solid var(--accent-gold);
  font-family: 'Inter', sans-serif;
  font-size: 12.5px;
  line-height: 1.7;
  color: var(--text-secondary);
  letter-spacing: 0.01em;
}
.inquiry-policy-note__line { margin: 0; }
.inquiry-policy-note strong {
  color: var(--text-primary);
  font-weight: 500;
}

.inquiry-process-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--accent-gold);
  font-family: 'Inter', sans-serif;
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  transition: color 0.25s ease;
}
.inquiry-process-toggle:hover { color: var(--text-primary); }
.inquiry-process-toggle svg {
  transition: transform 0.35s cubic-bezier(.2,.8,.2,1);
}
.inquiry-process-toggle.is-open svg { transform: rotate(180deg); }

.inquiry-process-panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.4s cubic-bezier(.2,.8,.2,1), margin-top 0.3s ease;
  overflow: hidden;
  margin-top: 0;
}
.inquiry-process-panel.is-open {
  grid-template-rows: 1fr;
  margin-top: 16px;
}
.inquiry-process-panel > * { min-height: 0; }

.inquiry-process-list {
  list-style: none;
  padding: 16px 0 4px;
  margin: 0;
  border-top: 1px solid rgba(201, 169, 97, 0.25);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.inquiry-process-item {
  display: grid;
  grid-template-columns: 32px 1fr;
  gap: 14px;
  align-items: start;
}

.inquiry-process-num {
  font-family: 'Playfair Display', serif;
  font-style: italic;
  font-size: 18px;
  color: var(--accent-gold);
  line-height: 1.2;
}

.inquiry-process-title {
  margin: 0 0 4px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-primary);
}

.inquiry-process-body {
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 12.5px;
  line-height: 1.65;
  color: var(--text-secondary);
}
    .commission-disclaimer__text {
      font-family: 'Playfair Display', serif;
      font-size: 14px;
      line-height: 1.85;
      font-style: italic;
      color: var(--text-secondary);
      margin: 0;
      letter-spacing: 0.01em;
    }
    .commission-disclaimer--pdp .commission-disclaimer__text {
      font-size: 13px;
      line-height: 1.75;
    }
    @media (max-width: 640px) {
      .commission-disclaimer { margin-top: 56px; }
      .commission-disclaimer__text { font-size: 13px; }
    }
  `;
  document.head.appendChild(css);
}

export default CommissionDisclaimer;
